import "../../../../resources/fonts/fonts.css"
const xxxsmallfont = "7px "
const xxsmallfont = "7.5px "
const xsmallfont = "8px "
const smallfont = "9px "
const mediumfont = "10px "
const largefont = "11px "
const xlargefont = "13px "
const xxlargefont = "16px "

const maxHeight = "62px"
const halfHeight = "30.5px"

    export const UnderlineStyles = {
        fontSize: largefont,
        textDecoration: "underline"
    }
    export const OutputContainerStyles = {
        color: "black ",
        backgroundColor: "white "
    }
    export const ExcludedCoverStyles = {
        minHeight: "95vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        pageBreakAfter: "always",
        breakAfter: "page"
    }
    export const ExcludedCoverTitleStyles = {
        maxWidth: "800px",
        marginBottom: "24px",
        fontSize: "24px",
        fontWeight: "bold"
    }
    export const ExcludedOperationStyles = {
        fontSize: "20px"
    }
    export const MainContainerStyles = {
        marginRight: (theme) => theme.spacing(2),
        marginLeft: (theme) => theme.spacing(2),
        fontSize: smallfont
    }
    export const LogoStyles = {
        maxWidth: "150px"
    }
    export const WarningStyles = {
        maxWidth: "30px"
    }
    export const WarningLabelStyles = {
        paddingLeft: "5px",
        fontSize: mediumfont
    }
    export const OutputNameStyles = {
        fontSize: xxlargefont,
        fontWeight: "bold",
        width: "100%"
    }
    export const PageNumberStyles = {
        fontSize: xlargefont
    }
    export const InspectionReportStyles = {
        fontSize: xxlargefont,
        textDecoration: "underline",
        fontWeight: "bold"
    }
    export const CustomerStyles = {
        fontSize: largefont,
        marginLeft: (theme) => theme.spacing(2)
    }
    export const DeptStyles = {
        fontSize: largefont,
        marginRight: (theme) => theme.spacing(2)
    }
    export const OutlineGridStyles = {
        border: "1px solid black"
    }
    export const SectionPartStyles = {
        marginLeft: (theme) => theme.spacing(1),
        marginRight: (theme) => theme.spacing(1),
        fontSize: largefont,
        marginTop: (theme) => theme.spacing(1),
        marginBottom: (theme) => theme.spacing(1)
    }

    export const JobSetupStyles = {
        fontSize: smallfont,
        paddingLeft: "2px",
        borderBottom: "1px solid black",
        borderLeft: "1px solid black",
        borderRight: "1px solid black"
    }
    export const BlankStyles = {
        fontSize: smallfont,
        borderBottom: "1px solid black",
        borderLeft: "1px solid black",
        marginLeft: "1px",
        paddingBottom: "25px"
    }
    export const GearBlankStyles = {
        fontSize: smallfont,
        borderBottom: "1px solid black",
        borderLeft: "1px solid black",
        marginLeft: "1px",
        paddingBottom: "24px"
    }
    export const InProcessStyles = {
        fontSize: smallfont,
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        borderLeft: "1px solid black",
        paddingBottom: "4px",
        paddingTop: "5px",
        paddingLeft: "1px"
    }
    export const DateStyles = {
        fontSize: smallfont,
        paddingLeft: "2px",
        borderBottom: "1px solid black",
        borderLeft: "1px solid black",
        borderRight: "1px solid black",
        paddingBottom: "13px"
    }
    export const DWGStyles = {
        fontSize: smallfont,
        paddingLeft: "2px",
        borderBottom: "1px solid black",
        borderLeft: "1px solid black",
        borderRight: "1px solid black"
    }
    export const StampStyles = {
        fontSize: smallfont,
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        paddingBottom: "13px",
        paddingLeft: "2px"
    }
    export const ActualStyles = {
        fontSize: smallfont,
        paddingLeft: "2px",
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        fontWeight: "bold"
    }
    export const NoCertStyles = {
        fontSize: smallfont,
        paddingLeft: "2px",
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        paddingBottom: "20px"
    }
    export const CertStyles = {
        fontSize: smallfont,
        paddingLeft: "2px",
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        paddingBottom: "6px"
    }
    export const MaterialStyles = {
        fontSize: smallfont,
        borderBottom: "1px solid black",
        borderLeft: "1px solid black",
        borderRight: "1px solid black",
        paddingBottom: "6px",
        paddingLeft: "2px"
    }
    export const NoMaterialStyles = {
        fontSize: smallfont,
        borderBottom: "1px solid black",
        borderLeft: "1px solid black",
        borderRight: "1px solid black",
        paddingBottom: "20px",
        paddingLeft: "2px"
    }
    export const OperatorStyles = {
        fontSize: smallfont,
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        paddingBottom: "16px"
    }
    export const MethodStyles = {
        fontSize: smallfont,
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        paddingBottom: "3px"
    }
    export const BaselineStyles = {
        fontSize: smallfont,
        borderBottom: "1px solid black",
        borderRight: "1px solid black"
    }
    export const ToolIdStyles = {
        fontSize: smallfont,
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        borderTop: "1px solid black",
        paddingBottom: "47px"
    }
    export const BluePrintStyles = {
        fontSize: smallfont,
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        borderTop: "1px solid black",
        paddingBottom: "31px"
    }
    export const ControlMethodStyles = {
        fontSize: smallfont,
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        borderTop: "1px solid black",
        paddingBottom: "47px"
    }
    export const DateInitStyles = {
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        borderTop: "1px solid black",
        paddingLeft: "2px",
        paddingBottom: "14px",
        width: "100%",
        fontSize: smallfont
    }
    export const BlankInitStyles = {
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        fontSize: smallfont,
        paddingBottom: "18px"
    }
    export const ControlBlankInitStyles = {
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        fontSize: smallfont,
        paddingBottom: "21px"
    }
    export const OpInsStyles = {
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        fontSize: smallfont
    }
    export const ControlOpInsStyles = {
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        fontSize: xsmallfont
    }
    export const EvenSpaceStyles = {
        width: "20%"
    }
    export const ControlEvenSpaceStyles = {
        width: "16%"
    }
    export const ControlEvenSpaceSmallStyles = {
        width: "10%"
    }
    export const CharacteristicStyles = {
        fontFamily: ["SlimIMS, Century "].join(","),
        paddingLeft: "2px",
        maxHeight: maxHeight,
        minHeight: maxHeight,
        fontSize: smallfont
    }
    export const CharacteristicKeyStyles = {
        fontFamily: ["SlimIMS, Century "].join(","),
        paddingLeft: "2px",
        maxHeight: maxHeight,
        minHeight: maxHeight,
        fontSize: smallfont,
        fontWeight: "bold"
    }
    export const CharacteristicBlankStyles = {
        paddingLeft: "2px",
        maxHeight: maxHeight,
        minHeight: maxHeight,
        fontSize: smallfont
    }
    export const CharacteristicBlankSmallStyles = {
        paddingLeft: "2px",
        maxHeight: maxHeight,
        minHeight: maxHeight,
        overflow: "hidden",
        fontSize: xxxsmallfont
    }
    export const CharacteristicCellStyles = {
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        borderLeft: "1px solid black",
        maxHeight: maxHeight,
        overflow: "hidden"
    }
    export const CharacteristicCellKeyStyles = {
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        borderLeft: "1px solid black",
        overflow: "hidden",
        maxHeight: maxHeight,
        fontWeight: "bold"
    }
    export const CharacteristicCellBlankStyles = {
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        maxHeight: maxHeight,
        overflow: "hidden"
    }
    export const CharacteristicEvenSpaceStyles = {
        width: "20%",
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        maxHeight: maxHeight,
        overflow: "hidden"
    }
    export const ControlCharacteristicEvenSpaceSmallStyles = {
        width: "10%",
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        maxHeight: maxHeight,
        overflow: "hidden"
    }
    export const ControlCharacteristicEvenSpaceStyles = {
        width: "16%",
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        maxHeight: maxHeight,
        overflow: "hidden"
    }
    export const CharacteristicEntryNum1Styles = {
        fontSize: xlargefont,
        borderRight: "1px solid black",
        minHeight: halfHeight,
        paddingRight: "1px"
    }
    export const CharacteristicEntry1Styles = {
        fontSize: smallfont,
        borderBottom: "1px solid black"
    }
    export const CharacteristicEntryNum2Styles = {
        fontSize: xlargefont,
        minHeight: halfHeight,
        borderRight: "1px solid black",
        paddingRight: "1px"
    }
    export const CharacteristicEntry2Styles = {
        fontSize: mediumfont,
        borderBottom: "1px solid black"
    }
    export const FooterBoxStyles = {
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
        borderLeft: "1px solid black"
    }
    export const FooterContentStyles = {
        fontSize: xxsmallfont
    }
    export const FooterContentRightStyles = {
        fontSize: xsmallfont,
        marginRight: (theme) => theme.spacing(2)
    }
    export const BaseLineFooterStyles = {
        paddingRight: "5px"
    }
    export const PaddingStyles = {
        width: "21%",
        paddingRight: "5px"
    }
    export const PaddingLargeStyles = {
        width: "30%"
    }
    export const BottomPushStyles = {
        bottom: "0"
    }
    export const OperatorInitStyles = {
        fontSize: mediumfont,
        width: "25%",
        borderRight: "1px solid black",
        borderBottom: "1px solid black",
        borderLeft: "1px solid black"
    }
    export const LargeBlankStyles = {
        width: "25%",
        borderRight: "1px solid black",
        borderBottom: "1px solid black"
    }
    export const ControlLargeBlankStyles = {
        width: "35%",
        borderRight: "1px solid black",
        borderBottom: "1px solid black"
    }
    export const ControlSmallBlankStyles = {
        width: "8%",
        borderRight: "1px solid black",
        borderBottom: "1px solid black"
    }
    export const SmallBlankStyles = {
        width: "10%",
        borderRight: "1px solid black",
        borderBottom: "1px solid black"
    }
    export const InitialsStyles = {
        fontSize: mediumfont
    }
    export const OpInstructionsStyles = {
        fontSize: mediumfont
    }
    export const PQFandDateStyles = {
        fontSize: mediumfont
    }
    export const PageBreakStyles = {
        fontSize: mediumfont,
        pageBreakAfter: "always"
    }
    export const PageBreakNoStyles = {
        fontSize: mediumfont
    }
    export const GearEvenSpaceStyles = {
        borderLeft: "1px solid black",
        borderRight: "1px solid black",
        borderBottom: "1px solid black",
        width: "17%"
    }
    export const GearEvenSpaceAltStyles = {
        borderRight: "1px solid black",
        borderBottom: "1px solid black",
        width: "17%"
    }
    export const GearEvenSpaceAlt2Styles = {
        borderRight: "1px solid black",
        borderBottom: "1px solid black",
        width: "16%"
    }
    export const SectionGearStyles = {
        marginLeft: (theme) => theme.spacing(1),
        marginRight: (theme) => theme.spacing(1),
        fontSize: smallfont
    }
    export const KeyIconStyles = {
        fontSize: largefont,
        marginRight: "2px"
    }
